import { Caption } from '@casavo/base-ui'

import { requiredLabelToken } from './styles.css'

type Props = {
  className?: string
  disabled?: boolean
  filled?: boolean
  label: React.ReactNode
  required?: boolean
}

const Label: React.FC<React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> & Props> =
  ({ children, className, label, required = false, ...props }) => {
    return (
      <Caption as="label" className={className} {...(props as Props)}>
        {label}

        {required ? <span className={requiredLabelToken}> &#42;</span> : null}

        {children}
      </Caption>
    )
  }

export default Label
